// @flow

// - Stylesheet
import './course-filters.less';

// - Vendors
import $        from 'jquery';
import { View } from '@insolus/backbone';

// - Models
import CoursesFilter from '../../models/courses-filter';

class CourseFilters extends View {
    get isPrerendered(): boolean { return true; }

    waitFiltersTime: number;
    filterTimeout: ?TimeoutID;
    filter: CoursesFilter;

    get events(): Object {
        return {
            'click .course-filters__item'   : 'selectFilterItem',
            'click .course-filters__return' : 'onReturnClick'
        };
    }

    initialize(options: { subjectId: number }) {
        this.waitFiltersTime = 6 * 100;
        this.filterTimeout   = null;
        this.filter          = new CoursesFilter({ subjectId: options.subjectId });

        this.render();
    }

    // ——————————————————————————————————————————————————————
    // —
    // —     Custom methods
    // —
    // ——————————————————————————————————————————————————————

    selectFilterItem(e: JQueryMouseEventObject) {
        const $item: JQuery    = $(e.currentTarget);
        const itemType: string = String($item.data('type'));
        const itemId: number   = parseInt($item.data('id'), 10);

        if (!this.filter.has(itemType)) {
            return;
        }

        const itemIndex: number = this.filter.get(itemType).indexOf(itemId);
        if (itemIndex >= 0) {
            this.filter.get(itemType).splice(itemIndex, 1);
            $item.removeClass('course-filters__item--selected');
        } else {
            this.filter.get(itemType).push(itemId);
            $item.addClass('course-filters__item--selected');
        }

        this.startFiltering();
    }

    startFiltering() {
        this.trigger('startFiltering', this.filter.clone());

        window.clearTimeout(this.filterTimeout);
        this.filterTimeout = setTimeout(
            this.getFilteredResults.bind(this),
            this.waitFiltersTime
        );
    }

    getFilteredResults() {
        this.trigger('filterSelected', this.filter.clone());
    }

    onReturnClick() {
        this.trigger('filterReturn');
    }

    onDestroy() {
        window.clearTimeout(this.filterTimeout);
        this.filterTimeout = null;
    }
}

export default CourseFilters;



// WEBPACK FOOTER //
// ./src/views/themes/front/components/course-filters/course-filters.js